import { CarouselItem } from '../../../core/models/item';
import { isSoloare, SiteType } from '../../../core/models/js_env';
import { RrAreaProfile } from '../../../core/models/rr_profile';
import { CategoryLlAndLJsEnv } from './category_ll_and_l_js_env';

/** 画面表示に必要なデータを管理する人 */
export class CategoryLlAndL {

  constructor(private model: CategoryLlAndLJsEnv, siteType: SiteType) {
    this.model = { ...model };

    if (!isSoloare(siteType)) {
      // rrAreaに表示するItemsとTitleは外部公開APIとRRサーバで取得するのでここは空で定義
      this.model.rrAreaProfileL1 = { placementName: "recomRR_l_01", displayCount: 3, rrAreaItems: [], rrAreaTitle: "", perView: 2 };
      this.model.rrAreaProfileL2 = { placementName: "recomRR_l_02", displayCount: 30, rrAreaItems: [], rrAreaTitle: "", perView: 5 };
      this.model.rrAreaProfileL3 = { placementName: "recomRR_l_03", displayCount: 5, rrAreaItems: [], rrAreaTitle: "", perView: 5 };

      this.model.rrAreaProfileLl1 = { placementName: "recomRR_ll_01", displayCount: 3, rrAreaItems: [], rrAreaTitle: "", perView: 5 };
      this.model.rrAreaProfileLl2 = { placementName: "recomRR_ll_02", displayCount: 30, rrAreaItems: [], rrAreaTitle: "", perView: 5 };
    } else {
      this.model.rrAreaProfileL1 = { placementName: "tr_recom_dai", displayCount: 3, rrAreaItems: [], rrAreaTitle: "", perView: 2 };
      this.model.rrAreaProfileLl1 = { placementName: "tr_recom_dai_dai", displayCount: 3, rrAreaItems: [], rrAreaTitle: "", perView: 5 };
    }
  }

  getModel(): CategoryLlAndLJsEnv {
    return this.model;
  }

  // 大大カテ画面、RRエリアは二つ
  setRrAreaProfilesLl(rrAreaProfileLl1: RrAreaProfile, rrAreaProfileLl2: RrAreaProfile): void {
    this.model.rrAreaProfileLl1 = rrAreaProfileLl1;
    this.model.rrAreaProfileLl2 = rrAreaProfileLl2;
  }

  setRrAreaDataLl1(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileLl1.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileLl1.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataLl2(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileLl2.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileLl2.rrAreaTitle = rrAreaTitle;
  }

  // 大カテ画面、RRエリアは三つ
  setRrAreaProfilesL(rrAreaProfileL1: RrAreaProfile, rrAreaProfileL2: RrAreaProfile, rrAreaProfileL3: RrAreaProfile): void {
    this.model.rrAreaProfileL1 = rrAreaProfileL1;
    this.model.rrAreaProfileL2 = rrAreaProfileL2;
    this.model.rrAreaProfileL3 = rrAreaProfileL3;
  }

  setRrAreaDataL1(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileL1.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileL1.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataL2(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileL2.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileL2.rrAreaTitle = rrAreaTitle;
  }

  setRrAreaDataL3(carouselItemList: CarouselItem[], rrAreaTitle: string): void {
    this.model.rrAreaProfileL3.rrAreaItems = carouselItemList;
    this.model.rrAreaProfileL3.rrAreaTitle = rrAreaTitle;
  }
}
